import { Component } from '@angular/core';

@Component({
	selector: 'pms-app-wrapper',
	templateUrl: './app-wrapper.component.html',
	standalone: false,
})
export class AppWrapperComponent {

	constructor() { }

}
